import { createV3Queries } from "@query/utils/createV3Queries";
import { payrollSchedulesApi } from "@api";

/**
 * Payroll-schedule registry — mirrors `PayrollSchedulesApi` 1:1.
 *
 * One schedule per `PayrollScheduleType` (`Employee` / `ContractorVendor`) drives
 * pay-period generation, the approval window and the pay date, so the
 * name-derived defaults refreshing `getPayrollSchedule` / `listPayrollSchedules`
 * after each write are what the settings screen needs.
 *
 * `previewPayrollSchedule` is a read shaped as a POST; it returns the upcoming
 * `PayrollSchedulePreviewPeriod[]` (period bounds, nominal vs adjusted pay date,
 * adjustment reason, approval-window start) that the schedule-preview table and
 * timeline render.
 */
export const queriesPayrollSchedules = createV3Queries(
  "payrollSchedulesApi",
  payrollSchedulesApi
);
